// SEO configuration and helpers

export const SITE_CONFIG = {
  name: "iQ Texting",
  domain: "https://iqtexting.com",
  defaultTitle: "iQ Texting - AI-Powered Website Chat & SMS Messaging Platform",
  defaultDescription: "Convert 30-50% more website visitors into customers with iQ Texting. Live team responses during business hours, AI handles after-hours. Multi-agent SMS routing, real-time dashboard, CRM integration. Start free trial today.",
  ogImage: "https://storage.googleapis.com/gpt-engineer-file-uploads/Ko5qCYiHXZZ3YW8vAskHB6vDBXe2/social-images/social-1759666833590-live-lead-connect-Lovable-10-04-2025_10_24_PM.jpg",
};

export const generatePageTitle = (pageTitle: string): string => {
  return `${pageTitle} | ${SITE_CONFIG.name}`;
};

export const generateCanonicalUrl = (path: string): string => {
  return `${SITE_CONFIG.domain}${path}`;
};
